<template>
	<div>
		<transition name="modal">
			<div class="modal-mask">
				<div class="modal-wrapper" @click="$emit('closeModal')">
					<div class="row">
						<div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
						<div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
							<div class="modal-container" @click.stop>

                <div class="modal-header row" style="justify-content: flex-end;">
                  <div class="col">
                    <button type="button" class="close" @click="$emit('closeModal')">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>

								<div class="modal-body">
                  <!-- Error -->
                  <h1 v-if="error.isError" class="text-center text-danger">{{ error.errorMessage }}</h1>

                  <!-- Content -->
                  <div v-else>
                    <!-- Title -->
                    <div v-if="config.title" class="row mb-3">
                      <div class="col">
                        <h1 class="text-center">{{ config.title }}</h1>
                      </div>
                    </div>

                    <!-- Images -->
                    <div class="row" v-if="imageCollection.length != 0">
                      <div
                        v-if="config.arrow"
                        class="col-md-2 align-middle text-center"
                        @click="changeImage(false)"
                        :class="(currentSelected == 0 && config.disableRotation) ? 'arrow-disabled' : 'clickAble'"
                      >
                        <i class="fas fa-angle-left fa-5x"></i>
                      </div>
                      <div class="col pl-5 pr-5 text-center">
                        <div class="text-center mt-3 mb-3">
                          <!-- <h4 class="mb-3">Download Gambar #{{currentSelected + 1}}</h4> -->
                          <!-- <button class="btn btn-secondary mr-3" @click="downloadImage('jpeg' , imageCollection[currentSelected].image , currentSelected) ">JPG</button>
                          <button class="btn btn-secondary ml-3" @click="downloadImage('png' , imageCollection[currentSelected].image , currentSelected) ">PNG</button> -->
                        </div>

                        <img
                          :src="imageCollection[currentSelected].image"
                          
                          class="w-100"
                          style="max-height:600px;max-width:700px;"
                          ref="image"
                          id="curImage"
                        >
                        <p
                          v-if="imageCollection[currentSelected].description != ''"
                          class="text-center mt-1"
                        >{{ imageCollection[currentSelected].description }}</p>

                        

                        <p v-if="!config.disableCounter" style="font-size:18px" class="text-center mt-2 mb-2">
                          <span class="font-weight-bold">{{ currentSelected+1 }}</span> of {{ imageCollection.length }}
                        </p>
                      </div>
                      <div
                        v-if="config.arrow"
                        class="col-md-2 align-middle text-center"
                        @click="changeImage(true)"
                        :class="(currentSelected == imageCollection.length-1 && config.disableRotation) ? 'arrow-disabled' : 'clickAble'"
                      >
                        <i class="fas fa-angle-right fa-5x"></i>
                      </div>
                    </div>

                    <!-- Overall Description -->
                    <div class="row" v-if="overallDescription != ''">
                      <div class="col">
                        <p :style="overallDescriptionStyle">{{ overallDescription }}</p>
                      </div>
                    </div>
                  </div>
                  <!-- End of Content -->

								</div>
							</div>
						</div>
						<div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
/*
  [IMPORTANT] - 'image' is REQUIRED

  'image' props content either of:
    > String ('http://www.sampleImage/1.png')
    > Array of String (['http://www.sampleImage/1.png', 'http://www.sampleImage/1.png', 'http://www.sampleImage/1.png'])
    > Array of Object - Contains 'image' and 'description' ([
      {
        'image' : 'http://www.sampleImage/1.png',
        'description' : 'This is a description'
      },
      {
        'image' : 'http://www.sampleImage/1.png'  //No description is also allowed
      },
      {
        'image' : 'http://www.sampleImage/1.png',
        'description' : 'This is a description'
      }
    ])

  *notes:
    - if you only have an image, and you want to put a description on it, you can use the 'description' props
    - you may combine string and object in an array if you would like
    - any other key in the object will be ignored, whilst 'image' is mandatory and 'description' is optional
*/
// const watermark = require('watermarkjs')
// import * as imageConversion from 'image-conversion';
import env from '@/env'

export default {
	data () {
		return {
      error : {
        isError : false,
        errorMessage : ''
      },
      config : {
        title : '',

        arrow : true,
        disableRotation : false,
        disableCounter : false,
      },

      //Image List & Current Position
      imageCollection : [],
      currentSelected : 0,

      //Overall Description & It's Style
      overallDescription : '',
      overallDescriptionStyle : '',
      newListImage : []
		}
  },
  
  props: [
    'image',//List of images or url of an image - String or Array of String or Array of Object [REQUIRED]
    'title',//Title to be shown at the top - String; DEFAULT null
    'description',//Description for all images - String; DEFAULT null
    'description_style',//Special style for description for all images - String; DEFAULT null
    'hide_arrow',//Hide arrows - Boolean; DEFAULT false (Single string 'image' is excepted to be 'true'; can be overwritten by this)
    'disable_rotation',//Disable rotation or unlimited left or right images - Boolean; DEFAULT false
    'disable_counter',//Disable counter like 1 of 3 - Boolean; DEFAULT false
    'start_image_counter' // Set Starting Image Counter
  ],
  mounted () {
    this.validateProps();
    if(this.start_image_counter)
      this.currentSelected = this.start_image_counter

          
  },
  watch : {
    description : {//REACTIVE
      handler(){
        if (this.description != null) {//Check 'description'
          if (typeof this.description == 'string')
            this.overallDescription = this.description
          else this.declareError("'description' must be a string")
        }
      },
      immediate : true
    },
    description_style : {//REACTIVE
      handler(){
        if (this.description_style != null) {//Check 'description_style'
          if (typeof this.description_style == 'string')
            this.overallDescriptionStyle = this.description_style
          else this.declareError("'description_style' must be a string")
        }
      },
      immediate : true
    }
  },
	methods: {
    async downloadImage(imageType , imgPath , index) {
      // console.log(imgPath)
      // fetch(imgPath)
      //   .then((res) => res.blob())
      //   .then((blob) => {
      //       // Read the Blob as DataURL using the FileReader API
      //       const reader = new FileReader();
      //       reader.onloadend = () => {
      //           // console.log(reader.result);
      //           // Logs data:image/jpeg;base64,wL2dvYWwgbW9yZ...

      //           // Convert to Base64 string
      //           const base64 = getBase64StringFromDataURL(reader.result);
      //           console.log(base64)
      //           imageConversion.dataURLtoFile(reader.result , `image/${imageType}`)
      //           .then(res => {
      //             console.log(res)
      //             imageConversion.downloadFile(res , `image.${imageType}`)
      //           })
      //       };
            reader.readAsDataURL(blob);
            
    //   let img = document.getElementById('curImage')
    //   // ctx.drawImage(img , 0 , 0)

    //   // console.log(canvas.toDataURL())
    //   let canvas = await imageConversion.imagetoCanvas(img)
    //   console.log(canvas)


    //   var link = document.createElement('a');
    //   link.download = `image.${imageType}`;
    //   link.href = canvas.toDataURL()
    //   link.click();
        // });


        let img = document.getElementById('curImage')

        
    },
    declareError(x){
      this.error.isError = true;
      this.error.errorMessage = x;
    },
    changeImage(direction){//false for left, true for right
      if (direction) {//right
        if (this.currentSelected+1 <= this.imageCollection.length - 1) this.currentSelected++
        else {
          if (!this.config.disableRotation) this.currentSelected = 0;
          else this.errorPrint('Rotation is disabled');
        }
      } else {//left
        if (this.currentSelected-1 >= 0) this.currentSelected--
        else {
          if (!this.config.disableRotation) this.currentSelected = this.imageCollection.length-1;
          else this.errorPrint('Rotation is disabled');
        }
      }
    },
    validateProps(){
      var images = []

      if(this.image != null){//Check 'image' [REQUIRED]
        if(Array.isArray(this.image)){
          for (var i in this.image){
            if (typeof this.image[i] == 'object'){
              if (this.image[i].image == null) this.declareError("One or more object in 'image' props do not contain an 'image' key")
              else if (this.image[i].image.includes('http://') || this.image[i].image.includes('https://'))
                images.push({image:this.image[i].image, description:this.image[i].description!=null ? this.image[i].description : ''})
            } else if (typeof this.image[i] == 'string'){
              console.log(env.baseImage + this.image[i])
              if (this.image[i].includes('http://') || this.image[i].includes('https://')) images.push({image:this.image[i], description:''})
              else {
                images.push({image: env.baseImage + '/' + this.image[i], description:''})
              }
            } else this.declareError("One or more of 'image' props' array contains a non-string or a non-object")
          }
        } else if (typeof this.image == 'string') {
          this.config.arrow = false;
          this.config.disableCounter = true;
          if (this.image.includes('http://') || this.image.includes('https://')) images.push({image:this.image, description:''})
          else {
            images.push({image:env.baseImage + '/' + this.image, description:''})
          }
        } else this.declareError("'image' must contain either an 'Array of String' or 'String'")
      } else this.declareError("'image' is a required props")

      if (this.title != null) {//Check 'title'
        if (typeof this.title == 'string')
          this.config.title = this.title
        else this.declareError("'title' must be a string")
      }

      //DESCRIPTION AND DESCRIPTION_STYLE CHECK IS DONE ON THE WATCH

      if (this.hide_arrow != null) {//Check 'hide_arrow'
        if (typeof this.hide_arrow == 'boolean')
          this.config.arrow = !this.hide_arrow
        else this.declareError("'hide_arrow' must be a boolean")
      }

      if (this.disable_rotation != null) {//Check 'disable_rotation'
        if (typeof this.disable_rotation == 'boolean')
          this.config.disableRotation = this.disable_rotation
        else this.declareError("'disable_rotation' must be a boolean")
      }

      if (this.disable_counter != null) {//Check 'disable_counter'
        if (typeof this.disable_counter == 'boolean')
          this.config.disableCounter = this.disable_counter
        else this.declareError("'disable_counter' must be a boolean")
      }

      this.imageCollection = images
    },
	}
}
</script>

<style>
  .modal-mask {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 100%;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 10px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  /* MODAL STARTS */
  .modal-body{
    margin:0
  }

  .modal-body .moduleLine{
    margin-bottom: 0vh;
  }

  .modal-body .moduleLine a{
    text-decoration: none;
  }

  .modal-body .moduleLine .moduleBox:hover{
    background-color: #E0E0E0;
    transition: background-color 0.7s ease;
    color: #212121;
    transition: color 0.7s ease;
  }

  .modal-body .moduleLine .moduleBox{
    border:1px solid #BDBDBD;
    border-radius: 20px;
    padding: 20px 0;
    color:black;
    margin-bottom: 3vh;
  }

  .modal-body .moduleLine .moduleBox i{
    font-size:5vh;
  }

  h3.modalHeadline{
    margin:0 0 20px 0
  }
  /* MODAL ENDS */

  .modalContent tr th{
    text-align:right;
  }

  .modalContent tr .middleDivider{
    width: 50px;
    text-align: center;
  }



  .align-middle{
    display: flex;
    flex-direction: column;
    justify-content: center; 
  }
  .clickAble:hover{
    cursor: pointer;
  }
  .arrow-disabled{
    color:#757575;
  }
</style>